import { useAuthentication } from '../../../utils/useAuthentication';
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import './custom-products.css';
import { IconEdit, IconPlus } from '@tabler/icons-react';
import Paper from '@mui/material/Paper';
import ModalProductTechniqueEdit from './ModalProductTechniqueEdit';
import { useProductsTechniques } from '../../../hooks/ProductsTechniques/useProductsTechniques';

const ProductsTechniquesView = () => {
  const data = useAuthentication();
  const user = data?.user?.account_data;
  const [techniques, setTechnique] = useState([]);
  const [selectedTechnique, setSelectedTechnique] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const { onListProductsTechniquesAdmin } = useProductsTechniques();

  useEffect(() => {
    onListProductsTechniquesAdmin().then((res) => {
      setTechnique(res);
    });
  }, []);

  const handleModalClose = useCallback(() => {
    onListProductsTechniquesAdmin().then((res) => {
      setTechnique(res);
      setEditMode(false);
    });
  }, []);

  return (
    <Box className="products-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <Box
        position={'fixed'}
        display={'flex'}
        right={10}
        bottom={10}
        bgcolor={'#2c3e50'}
        p={'10px'}
        borderRadius={'100%'}
        w={'50px'}
        h={'50px'}
        color={'white'}
        justifyContent={'center'}
        alignItems={'center'}
        cursor={'pointer'}
        onClick={() => {
          setSelectedTechnique(null);
          setEditMode(true);
        }}
      >
        <IconPlus stroke={3} size="2rem" />
      </Box>

      <ModalProductTechniqueEdit
        user={user}
        modalOpen={editMode}
        handleModalClose={handleModalClose}
        technique={selectedTechnique}
        setEditMode={setEditMode}
      />

      <Typography variant={'h4'} align={'center'} textTransform={'uppercase'} fontSize={20} my={2}>
        Tecniche Prodotti
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ width: '100%' }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Nome</TableCell>
              <TableCell align="center">Azioni</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {techniques?.map((row, index) => (
              <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" align={'center'}>
                  {row.name}
                </TableCell>
                <TableCell align="center">
                  <IconEdit
                    cursor={'pointer'}
                    onClick={() => {
                      setSelectedTechnique(row);
                      setEditMode(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default ProductsTechniquesView;
